import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { CreateChancel, Input } from 'components';
import { httpRequestsOnErrorsActions, httpRequestsOnSuccessActions, resourceActions } from 'store';
import { FindLoad, FindErrorItem, useModal, FindSuccessItem, Images } from 'utils';

export const AddResource = ({ info, closeToSuccess }) => {
    const ACTION_TYPE = info ? 'EDIT_RESOURCE' : 'CREATE_RESOURCE';
    const dispatch = useDispatch();
    const success = FindSuccessItem(ACTION_TYPE);
    const loader = FindLoad(ACTION_TYPE);
    const backError = FindErrorItem(ACTION_TYPE);
    const { close } = useModal();
    const {
        handleSubmit,
        control,
        setError,
        clearErrors,
        reset,
        formState: { errors },
    } = useForm();

    useEffect(() => {
        if (info) {
            const result = {
                ...info,
            };
            reset(result);
        }
    }, [info]);

    useEffect(() => {
        return () => {
            clearErrors();
            dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));
        };
    }, []);

    useEffect(() => {
        if (success) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
            close();
            if (closeToSuccess) {
                closeToSuccess();
            }
        }
    }, [success]);

    useEffect(() => {
        if (backError?.error?.length) {
            if (backError?.error[0] === 'website must be a URL address') {
                setError('website', {
                    message: 'Website must be a URL address.',
                });
                dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));
            }
        }
    }, [backError]);

    const handleCreate = (data) => {
        if (info) {
            dispatch(resourceActions.editResource(info.id, data));
        } else {
            dispatch(resourceActions.createResource(data));
        }
    };

    return (
        <div style={{ width: 400 }}>
            <p className="modal-header-title">{info ? 'Edit Folder' : 'Add Folder'}</p>
            <form onSubmit={handleSubmit(handleCreate)}>
                <div className="modal-body-wrapper">
                    <div className="full-width">
                        <Input
                            name="name"
                            label="Folder Name*"
                            variant="outlined"
                            control={control}
                            maxLength={40}
                            rules={{
                                maxLength: {
                                    value: 40,
                                    message: 'Max length is 40 digits.',
                                },
                                required: 'Folder name is required.',
                            }}
                        />
                    </div>

                    <div className="flex-align-center" style={{ gap: 8 }}>
                        <img src={Images.infoCircle} alt="info" />
                        <p className="add-folder-info-text">You can add tags and access after folder creation.</p>
                    </div>
                </div>
                <CreateChancel
                    type="submit"
                    loader={!!loader.length}
                    create={info ? 'Save' : 'Add'}
                    chancel={'Cancel'}
                    onClose={close}
                    buttonWidth="100%"
                    cancelRight={'24px'}
                />
            </form>
        </div>
    );
};
